seedWebApp.controller('IntegrationRecentsController', ['$scope', '$rootScope', '$window', '$uibModal', 'ToastService', 'TranslationService', 'IntegrationMonitorService',
    function ($scope, $rootScope, $window, $uibModal, ToastService, TranslationService, IntegrationMonitorService) {

        $scope.translation = TranslationService.getActiveTranslation();
        $scope.prefs = {
            name: 'RecentsGrid',
            sortByCol: null,
            canAdd: false,
            canEdit: true,
            canDelete: false,
        };

        $scope.getIDClass = function (item) {
            return 'agp-color';
        };

        $scope.getStatusClass = function (item) {
            if (item) {
                return 'label label-default background-label-' + item.toLowerCase();
            }
            return '';
        };        

        $scope.dateFormat = 'dd/MM/yyyy HH:mm:ss';
        $scope.columns = [
            { name: 'IntegrationID', display: 'Integração', orderBy: 'asc', editable: false, width: 5, isKey: true, customClass: $scope.getIDClass },  //filterOptions: []
            { name: 'IntegrationName', display: 'Nome Integração', editable: true, width: 15 },
            { name: 'ScopeID', display: 'Scope', editable: true, width: 5 },
            { name: 'DateCreated', display: 'Criado', dataType: 'timeago', format: $scope.dateFormat, isUTC: true, width: 5 },
            { name: 'LastExecutionDateStarted', display: 'Iniciado', dataType: 'date', format: $scope.dateFormat, isUTC: true, width: 5 },
            { name: 'LastExecutionDateFinished', display: 'Finalizado', dataType: 'date', format: $scope.dateFormat, isUTC: true, width: 5 },
            { name: 'LastExecutionStatus', display: 'Status', editable: true, width: 5, customClass: $scope.getStatusClass  },
            { name: 'LastExecutionItemsProcessed', display: 'Nr Items', editable: true, width: 5 },
        ];

        //$scope.prefs.sortByCol = $scope.columns[0];
        //$scope.prefs.sortByCol.orderReverse = false;

        $scope.loadService = IntegrationMonitorService.getIntegrationRecents;
        $scope.resetService = IntegrationMonitorService.resetCache;
        //$scope.loadColumns = ContactService.getContactsColumns;

        $scope.getTotal = function () {
            $scope.totalItems = 0;
            $scope.lastSync = null;
            $scope.loadingTotal = true;
            //ContactService.getRoutesCount().then(function (response) {
            //    $scope.loadingTotal = false;
            //    if (response) {
            //        $scope.totalItems = response.data.TotalCount;
            //        $scope.lastSync = response.data.LastSync;
            //    }
            //});
        };

        $scope.getTotal();

        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.prefs.customEdit = function (item) {
            var url = '/Integrations/IntegrationScope/' + item.IntegrationID + '/' + item.ScopeID;

            console.log('abrir ' + url);

            //$location.path(url, '_blank');
            $window.open(url, '_blank');
        };


        //$scope.toExcel = function () {
        //    $scope.$broadcast('toExcel', 'rotas');
        //};

        //$scope.doInsert = function () {
        //    $scope.$broadcast('addItem');
        //};

        //$(document).ready(function () {
        //    $scope.overflowSize = $scope.AdjustSize();
        //});

    }]);
